import { useMemo } from 'react';
import { ScDepositSection } from '@/components/Deposit/styled';
import { amountWithCurrencySymbol, mapCurrencyName } from '@/helpers/currency';
import { useGetCommonStore } from '@/store/commonStore';
import { CurrencyItem } from './CurrencyItem';

export const CurrenciesEnableBlock = () => {
  const useCommonStore = useGetCommonStore();

  const pendingWallets = useCommonStore.use.pendingWallets();
  const extendedUserWallets = useCommonStore.use.extendedUserWallets();

  const optionsWallets = useMemo(
    () =>
      extendedUserWallets.map(
        ({ amountCents, currency, subCurrency, icon }) => {
          const name = mapCurrencyName[currency];

          return {
            name: `${amountWithCurrencySymbol(subCurrency, amountCents)}${
              name ? ` | ${name}` : ''
            }`,
            value: currency,
            icon,
          };
        }
      ),
    [extendedUserWallets]
  );

  return (
    <ScDepositSection>
      {/* TODO: add translate */}
      <h3 className="title">Active currencies</h3>
      <div className="list">
        {optionsWallets.map(({ value, name, icon }) => (
          <CurrencyItem
            currencyCode={value}
            disableButton={optionsWallets.length === 1 || pendingWallets}
            icon={icon}
            isActive
            key={value}
            label={name}
          />
        ))}
      </div>
    </ScDepositSection>
  );
};
